import { EntityType } from '@frontend/common';
import { ObjectSelectInputV2, ObjectSelectV2Props } from '@frontend/form';
import { EquipmentGroupClient, ProductCategoryClient, ProductGroupClient, QuestionnaireClient, UserGroupClient } from '@frontend/group/api';
import { GroupQueryParams, IGroup } from '@frontend/group/types';
import { getCorrectTranslation, useLocale } from '@frontend/lang';
import React, { useState } from 'react';

const ID = 'group-select';
export interface GroupSelectProps extends ObjectSelectV2Props<IGroup, GroupQueryParams> {
    placeholder?: string;
    /**
     * @description only used for initialisation
     */
    objectValue?: IGroup | null;
    type: EntityType;
}
/**
 * @deprecated
 */
export const GroupSelect = (props: GroupSelectProps) => {
    const { locale } = useLocale();
    const [v, cV] = useState<IGroup | null>(props.objectValue || null);
    return (
        <ObjectSelectInputV2<IGroup, GroupQueryParams>
            {...props}
            id={`${ID}${props.id && '-' + props.id}`}
            key={`${ID}${props.id && '-' + props.id}`}
            label={props.label || 'IGroup'}
            className={props.className}
            placeholder={props.placeholder}
            onChange={(v) => {
                props.onChange && props.onChange(v?.id || null);
                props.onChangeObject && props.onChangeObject(v);
                cV(v);
            }}
            required={props.required}
            queryParams={props.queryParams}
            value={v}
            searchValueOverwrite={props.searchValueOverwrite}
            idValue={props.value || v?.id}
            fetch={(arg) => {
                switch (props.type) {
                    case EntityType.USER_GROUP:
                        return UserGroupClient.fetchUserGroups({ ...arg, sort_field: 'name', sort_direction: 'asc' });
                    case EntityType.EQUIPMENT_GROUP:
                        return EquipmentGroupClient.fetchEquipmentGroups({ ...arg, sort_field: 'name', sort_direction: 'asc' });
                    case EntityType.PRODUCT_GROUP:
                        return ProductGroupClient.fetchProductGroups({ ...arg, sort_field: 'name', sort_direction: 'asc' });
                    case EntityType.PRODUCT_CATEGORY:
                        return ProductCategoryClient.fetchProductCategories({ ...arg, sort_field: 'name', sort_direction: 'asc' });
                    case EntityType.QUESTIONNAIRE:
                        return QuestionnaireClient.fetchQuestionnaires({ ...arg, sort_field: 'name', sort_direction: 'asc' });
                }
                throw new Error(`Unknown group type ${props.type}`);
            }}
            itemLabel={(group) => (props.type === EntityType.PRODUCT_CATEGORY ? getCorrectTranslation(locale, group, 'name') : group.name)}
            disableFetch={props.disableFetch}
            disabled={props.disabled}
            isClearable={props.isClearable}
            subset={props.subset}
            onFocus={props.onFocus}
            onBlur={props.onBlur}
            helpMessage={props.helpMessage}
        />
    );
};
